import { ErrorBoundary } from 'solid-js';
// import { styled } from 'solid-styled-components';

type ErrorCatcherProps = {
    componentName: string;
    children: any;
};



export const ErrorCatcher = (props: ErrorCatcherProps) => {
    return (
        <ErrorBoundary fallback={(err: Error) => {
            const message = `Error caught in ${props.componentName}`;
    
            console.error(message, err);
            
            return (
                <>
                    {message}: {err?.toString()}
                </>
            );
        }}>
            {props.children}
        </ErrorBoundary>
    );
};